import { render, staticRenderFns } from "./MailSegnalazioniInbox.vue?vue&type=template&id=427c90a5&scoped=true"
import script from "./MailSegnalazioniInbox.vue?vue&type=script&lang=js"
export * from "./MailSegnalazioniInbox.vue?vue&type=script&lang=js"
import style0 from "./MailSegnalazioniInbox.vue?vue&type=style&index=0&id=427c90a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427c90a5",
  null
  
)

export default component.exports